export enum MainFrontendConfigFieldAccess {
    hidden = 0,
    readOnly = 1,
    editable = 2
}
export namespace MainFrontendConfigFieldAccess{
    export function getName(value: MainFrontendConfigFieldAccess): string {
        switch (value) {
            case MainFrontendConfigFieldAccess.hidden:
                return "hidden";
            case MainFrontendConfigFieldAccess.readOnly:
                return "readOnly";
            case MainFrontendConfigFieldAccess.editable:
                return "editable";
            default:
                return "???";
        }
    }
}
